import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Personal_Info from "./personal_info";
import ClinicalInformation from "./clinical_Info";
import EducationalInfo from "./educational_info";
import { paddingboxeven, pcolor, rcolor, tabPanelHealthProfile, whitecolor } from "../../style2";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function HealthProfileTabs(data) {

  const [value, setValue] = React.useState(data.defaulttab);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const tabStyle = {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: 18,
    textTransform: "unset",
    color: pcolor
  };

  return (
    <Box sx={paddingboxeven} pb={10}>
      <Box pt={3} sx={{ width: "100%", backgroundColor: whitecolor, borderRadius: 9, }}>
        <Tabs TabIndicatorProps={{ style: { background: rcolor } }}
          variant='fullWidth' value={value} onChange={handleChange}>
          <Tab style={tabStyle} label='Personal Information' {...a11yProps(0)} />
          <Tab style={tabStyle} label='Clinical Information' {...a11yProps(1)} />
          <Tab style={tabStyle} label='Educational Information' {...a11yProps(2)} />
        </Tabs>
        <TabPanel id="asdadasdsad" value={value} index={0} sx={tabPanelHealthProfile}>
          <Personal_Info profile={data.profile}/>
        </TabPanel>
        <TabPanel value={value} index={1} sx={tabPanelHealthProfile}>
          <ClinicalInformation profile={data.profile} />
        </TabPanel>
        <TabPanel value={value} index={2} sx={tabPanelHealthProfile}>
          <EducationalInfo  profile={data.profile} />
        </TabPanel>
      </Box>
    </Box>
  );
}

export default HealthProfileTabs;
